export default __webpack_public_path__ + "static/media/separator_white.431ea3fd.svg";